<template>
  <div class="py-4 container-fluid">
    <GridRow class=" row">
      <GridCol :size="12">
        <MetaSection>
          <div class="text-right">
            <argon-button :to="{ name: 'Create Target Konsolidasi' }" :isRouteLink="true"><font-awesome-icon icon="fa-solid fa-plus" /> Tambah {{ ((title ?? this.$route?.meta?.title) ?? this.$route?.name) }}</argon-button>
          </div>
        </MetaSection>
      </GridCol>
      <GridCol :xs="12">
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :md="8">
                <div class="d-flex align-items-center justify-content-between gap-2">
                  <InputGroup class="w-100">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="searchKeyword()" type="text" class="form-control"
                      placeholder="Cari nama cabang disini..." style="border-right: 1px solid #d2d6da!important;">
                  </InputGroup>

                  <FormGroup class="m-0 w-100">
                    <model-list-select
                      class="form-control"
                      v-model="params.periode_id"
                      :list="list_periode"
                      option-value="id"
                      option-text="name"
                      placeholder="Pilih Periode"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 w-100">
                    <model-list-select
                      class="form-control"
                      v-model="params.unitkerja_id"
                      :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Pilih Cabang"
                    />
                  </FormGroup>

                  <!-- <FormGroup class="m-0 w-100">
                    <select-form v-model="params.status" @change="getData()" placeholder="Pilih Status" :options="[
                      {
                        value: 'active',
                        text: 'Aktif',
                      },
                      {
                        value: 'inactive',
                        text: 'Tidak Aktif',
                      },
                    ]" />
                  </FormGroup> -->
                </div>
              </GridCol>
            </GridRow>
          </template>
          <list-view :thead="['Periode', 'Nama', 'Kode', 'Keterangan', 'Status', 'Aksi']">
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="6" class="text-center text-secondary py-4">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ item?.periode || '-' }}</td>
                <td>{{ item?.cabang || '-' }}</td>
                <td>{{ item?.kode_cabang || '-' }}</td>
                <td>{{ item?.keterangan || '-' }}</td>
                <td>
                  <template v-if="item?.status">
                    <argon-badge :color="item?.status === 'active' ? 'success' : 'danger'">{{ item?.status === 'active' ? 'Aktif' : 'Non Aktif' }}</argon-badge>
                  </template>
                  <span v-else>-</span>
                </td>
                <td class="align-middle">
                  <ThreeDotsMenu>
                    <router-link :to="{ name: 'Detail Target Konsolidasi', params: { id: item?.id } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Detail">Lihat Detail</router-link>
                    <router-link :to="{ name: 'Update Target Konsolidasi', params: { id: item?.id } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Edit">Edit</router-link>
                    <!-- <button @click.prevent="deleteData(item.id)"
                      class="text-secondary font-weight-bold text-xs btn btn-link" role="link" data-toggle="tooltip"
                      data-original-title="Delete user">Hapus</button> -->
                    <button type="button" @click="deleteData(item.id)"
                      class="text-secondary font-weight-bold text-xs btn btn-link">Hapus</button>
                    <!-- <span>Hapus</span> -->
                  </ThreeDotsMenu>
                </td>
              </tr>
              <!-- <tr v-for="(item, index) in data" :key="index">
                <td>{{ item.nama_penilaian_kinerja ?? "-" }}</td>
                <td><div class="column-truncate">{{ item?.unitkerja ?? "-" }}</div></td>
                <td><div class="column-truncate">{{ item?.jabatan ?? "-" }}</div></td>
                <td>
                  <argon-badge v-if="item.status == 'active'" color="success">Aktif</argon-badge>
                  <argon-badge v-if="item.status == 'inactive'" color="danger">Non Aktif</argon-badge>
                </td>
                <td class="align-middle">
                  <ThreeDotsMenu>
                    <router-link :to="{ name: 'Update Penilaian Kinerja', params: { id: item?.id ?? 0 } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Edit user">Edit</router-link>
                    <button @click.prevent="deleteData(item.id)"
                      class="text-secondary font-weight-bold text-xs btn btn-link" role="link" data-toggle="tooltip"
                      data-original-title="Delete user">Hapus</button>
                  </ThreeDotsMenu>
                </td>
              </tr> -->
            </template>
            <ArgonPagination :page="params.page" :total_page="metaData.total_page" :current_page="metaData.current_page" @changepage="changePage" @changelimit="changeLimit" />
          </list-view>
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import FormGroup from '@/components/FormGroup.vue';
import ArgonBadge from '@/components/ArgonBadge.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import ListView from '@/components/ListView.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import ArgonPagination from '@/components/ArgonPagination.vue';

import TargetKonsolidasiApi from '@/repository/api/TargetKonsolidasiApi';
import KpiPeriodeApi from '@/repository/api/KpiPeriodeApi';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import MetaSection from "@/components/MetaSection.vue";

export default {
  name: "tables",
  components: {
    MetaSection,
    CardComponent,
    InputGroup,
    FormGroup,
    ArgonBadge,
    ArgonButton,
    ThreeDotsMenu,
    ListView,
    GridRow,
    GridCol,
    ArgonPagination,
    ModelListSelect,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      unitkerja: [],
      jabatan: [],
      list_periode: [],
      params: {
        limit: "",
        keyword: "",
        unitkerja_id: "",
        periode_id: "",
        // status: '',
        page: 1,
      },
      metaData: {},
    };
  },
  watch: {
    'params.periode_id': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.limit': {
      handler: async function () {
        this.params.page = 1
        await this.getData();
      },
      deep: false,
    },
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          await this.getData();
        }
      },
      deep: false,
    },
    'params.unitkerja_id': {
      handler: async function () {
        this.params.page = 1;
        this.params.jabatan_id = "";
        // await this.getJabatan();
        await this.getData();
      },
      deep: true,
    },
  },
  methods: {
    changeLimit(limit) {
      this.params.limit = limit
    },
    changePage(page) {
      this.params.page = page
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.getbyparam({page: "all", status: "active"}).then((response) => {
        this.unitkerja = response.data;
      }).catch(() => {
        this.params.jabatan_id = "";
        this.unitkerja = [];
      });
      this.$store.state.loading = false;
    },
    async getKpiPeriode() {
      await KpiPeriodeApi.getbyparam({
        status: 'active',
        limit: 100,
      })
        .then((response) => {
          this.list_periode = response?.data || [];
          this.params.periode_id = response?.data?.[0]?.id || '';
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async searchKeyword() {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        await this.getData();
      }, 650);
    },
    async getData() {
      this.$store.state.loading = true;
      let params = {}
      Object.keys(this.params).forEach(key => {
        if (!(this.params[key] === undefined || this.params[key] === null || this.params[key] === "")) {
          params[key] = JSON.parse(JSON.stringify(this.params[key]))
        }
      });
      await TargetKonsolidasiApi.getByParams(params)
        .then((response) => {
          this.data = response.data;
          this.metaData = {
            status: response?.status ?? null,
            message: response?.message ?? null,
            total_item: response?.total_item ?? null,
            per_page: response?.per_page ?? null,
            total_page: response?.total_page ?? null,
            current_page: response?.current_page ?? null,
          }
        })
        .catch((error) => {
          if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
            this.params.page = 1;
          }
          this.data = [];
        });
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await TargetKonsolidasiApi.delete(id)
            .then(() => {
              this.getData();
              this.$swal({
                icon: "success",
                title: "Berhasil"
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Error",
                text: error?.response?.data?.message || 'Something wrong, please try again.',
              });
            });
          this.$store.state.loading = false;
        }
      })
    }
  },
  async mounted() {
    await this.getKpiPeriode()
    await this.getUnitKerja();
    await this.getData();
  },
};
</script>
